module.exports = __webpack_public_path__ + "img/prompt.2214a6e2.png";